import type { ColGroupDef } from 'ag-grid-community';
import type { IntlKey } from 'locales';
import { useMemo } from 'react';

import { useHeaderValueGetter } from './useHeaderValueGetter';

export function useDefaultGroupColumnDefinition(
  getHeaderIntlKey: (columnName: string) => IntlKey,
  customization?: Partial<ColGroupDef>,
) {
  const headerValueGetter = useHeaderValueGetter(getHeaderIntlKey);

  return useMemo(
    () =>
      ({
        headerValueGetter,
        marryChildren: false,
        openByDefault: true,
        ...(customization ?? {}),
      }) as Partial<ColGroupDef>,
    [customization, headerValueGetter],
  );
}
